import React, { useEffect, useRef, useState } from "react";
import { connect } from 'react-redux'
import styles from './OwnForm.module.scss'
import stylesAgreement from './components/OwnFormAgreement.module.scss'
import {
    DEBUG,

} from "../../../../settings/global";
import { updateBodyServer } from "../../../../redux/actions/DeploymentActions";
import Input from "../../../../components/Input";
import Button from "../../../../components/ripple/Button";
import { copyToClipboard, generateSlug, } from "../../../../helpers/common";
import Card, { CardItem } from "../../../../components/card/Card";
import Messages from "../../../../components/Messages";
import Link from "next/link";
import { getCommand } from "./_fetch/command";
import { checkConnectionStatus } from "./_fetch/copy";
import {
    LISTENING_INTERVAL,
    OWN_STATUS_ERROR,
    OWN_STATUS_IDLE,
    OWN_STATUS_LISTENING, OWN_STATUS_LOADING, OWN_STATUS_SUCCESS, OWN_STATUS_WAIT_AGREE
} from "../../../../settings/content/deploymentOwn";
import OwnDebugger from "./components/OwnDebugger";
import { dispatchNotification } from "../../../../layouts/app/components/notificationSystem/notifications";
import OwnStatusBlock from "./components/OwnStatusBlock";
import OwnLogs from "./components/OwnLogs";
import Loading from "../../../../components/Loading";
import OwnFormAgreement from "./components/OwnFormAgreement";
import { addModalLayer, wipeModalState } from "../../../../redux/actions/ModalActions";
import { getAgreementStatusFor, setAgreedFor } from "../../../../helpers/data/get/agreement";
import { NAV_CLOUDS } from "../../../../settings/navigation";
import { ID_AGREEMENT_OWN } from "../../../../settings/content/deploymentStacker";

function OwnForm({currentCloud, bodyCloud, bodyServer, messages, custom, onRefuse, dispatch}) {

    const listeningInterval = useRef();

    const [form, setForm] = useState({
        srv_ip: bodyServer.srv_ip || '',
        ssh_user: bodyServer.ssh_user || null,
        ssh_port: bodyServer.ssh_port || '',
    });
    const [agreed, setAgreed] = useState(false);
    const [cmd, setCMD] = useState('');
    const [connectError, setConnectError] = useState('');
    const [status, setStatus] = useState(OWN_STATUS_LOADING);
    const [showDebug, setShowDebug] = useState(false);
    const [log, setLog] = useState({});
    const [logs, setLogs] = useState([]);

    const pushOwnLog = (message, group = 'event', type) => {
        setLog({message, group, type, timestamp: Date.now(),})
    }

    const updateOwn = (data) => dispatch(updateBodyServer(data));

    const _setStatus = (status) => {
        setStatus(status);
        updateOwn({status})
    }

    const getCMD = () => {
        getCommand(
            command => {
                setCMD(command)
                setConnectError('');
                _setStatus(OWN_STATUS_IDLE);
                pushOwnLog('New command was generated', undefined);
                pushOwnLog('Please copy the command above and paste it on your server!', 'hint', 'info');
            },
            response => {
                setCMD('');
                setConnectError('');
                _setStatus(OWN_STATUS_ERROR);
                pushOwnLog('Error occurred during command generation', 'error', 'error');
            }
        )
    }

    useEffect(() => {

        _setStatus(OWN_STATUS_LOADING);

        getAgreementStatusFor(
            ID_AGREEMENT_OWN,
            () => setAgreed(true),
            () => {
                _setStatus(OWN_STATUS_WAIT_AGREE);
                dispatch(addModalLayer({
                    component: (
                        <OwnFormAgreement
                            agreement={currentCloud.config.selfHostedAgreement}
                            custom={custom}
                            onRefuse={onRefuse}
                            onAgree={() => {
                                setAgreedFor(
                                    ID_AGREEMENT_OWN,
                                    () => {
                                        setAgreed(true);
                                        _setStatus(OWN_STATUS_LOADING);
                                        dispatch(wipeModalState());
                                    },
                                    response => {
                                        dispatchNotification({
                                            message: response?.responseBody?.message || 'An error occurred on our side',
                                            type: 'error',
                                            errorFetch: response,
                                        })
                                    },
                                )
                            }}
                        />
                    ),
                    classNameModal: stylesAgreement.modal,
                    classNameLayer: stylesAgreement.modal__layout,
                    preventClose: true,
                }))
            },
        );

        return () => {
            clearInterval(listeningInterval.current);
            dispatch(wipeModalState());
            _setStatus(OWN_STATUS_LOADING);
            setAgreed(false);
        }
    }, []);

    useEffect(() => {
        if (!!agreed) {
            clearInterval(listeningInterval.current);
            getCMD();
        }
    }, [agreed]);

    useEffect(() => {
        if (!!Object.keys(log || {}).length) {
            setLogs([...logs, ...[log]])
        }
    }, [log]);

    const onChange = (e) => {
        let {value, name} = e.target;

        if (name === 'ssh_port') {
            value = !isNaN(parseFloat(value)) ? parseFloat(value) : null
        }

        setForm({...form, ...{[name]: value}});
        updateOwn({[name]: value});
    };

    const handleConnectRequest = () => {

        setConnectError('');
        _setStatus(OWN_STATUS_LISTENING);

        checkConnectionStatus(
            form,
            data => {
                updateOwn({is_connected: data.connected});
                pushOwnLog(`No server was found by scan result. New scan started...`, 'ping');

                if (data.connected === 1) {
                    _setStatus(OWN_STATUS_SUCCESS);
                    clearInterval(listeningInterval.current);
                    pushOwnLog('Server was successfully connected!', 'success', 'success');
                }
            },
            data => {
                if (data.status === 400) {
                    updateOwn({is_connected: false})
                    setConnectError(data.responseJSON?._error?.message);
                    _setStatus(OWN_STATUS_ERROR);
                    clearInterval(listeningInterval.current);
                    pushOwnLog(`An unexpected error occurred`, 'error', 'error');
                }
            }
        )
    };

    let statusMessage = '';

    switch (status) {
        case OWN_STATUS_WAIT_AGREE:
            statusMessage = 'Waiting for agreement consent';
            break;
        case OWN_STATUS_LISTENING:
            statusMessage = 'Waiting for connection...';
            break;
        case OWN_STATUS_SUCCESS:
            statusMessage = 'Connected!';
            break;
        case OWN_STATUS_ERROR:
            statusMessage = 'An error occurred';
            break;
        case OWN_STATUS_IDLE:
            statusMessage = 'Waiting for command copy';
            break;
        case OWN_STATUS_LOADING:
            statusMessage = 'Loading...';
            break;
        default:
            statusMessage = 'Unexpected status';
    }

    const handleCopyWithoutConnect = () => {
        copyToClipboard(
            'cmd-own',
            {message: `Copied to clipboard! Login via SSH on your server and paste the command`},
            true
        );
        if (!!DEBUG) {
            setTimeout(() => {
                dispatchNotification({
                    message: '[dev] After connection process is started this is just a simple copy',
                    type: 'warning'
                })
            }, 50)
        }
    }

    const handleCopyAndConnect = () => {
        pushOwnLog(`Server scan has been started`, undefined);
        copyToClipboard(
            'cmd-own',
            {message: `Copied to clipboard! Login via SSH on your server and paste the command`},
            true
        );
        handleConnectRequest();
        listeningInterval.current = setInterval(handleConnectRequest, LISTENING_INTERVAL);
    };

    const allowedCopyWithoutConnect = (
        !!cmd
        && status !== OWN_STATUS_SUCCESS
        && status !== OWN_STATUS_LOADING
        && status !== OWN_STATUS_WAIT_AGREE
        && !messages.some(m => m.type === 'error' && m.block === `own-form-inputs`)
    );

    const disabledCopyAndConnect = (
        !cmd
        || status === OWN_STATUS_LISTENING
        || status === OWN_STATUS_SUCCESS
        || status === OWN_STATUS_LOADING
        || status === OWN_STATUS_WAIT_AGREE
        || messages.some(m => m.type === 'error' && m.block === `own-form-inputs`)
    );

    const disabledInputs = (
        !cmd
        || status === OWN_STATUS_LISTENING
        || status === OWN_STATUS_SUCCESS
        || status === OWN_STATUS_LOADING
        || status === OWN_STATUS_WAIT_AGREE
    );

    return (
        <div className={styles.layout}>
            <Card
                style={{marginBottom: '10px'}}
                id={`own-form`}
                messages={messages}
            >
                <OwnStatusBlock status={status} statusMessage={statusMessage}/>
                <div>
                    <CardItem id='own-form-inputs' messages={messages}>
                        {
                            !!connectError &&
                            <Messages
                                messages={[{message: connectError, type: 'error'}]}
                                padding={`0 0 10px 18px`}
                            />
                        }
                        <div className={styles.form}>
                            <Input
                                className={styles.form__ip}
                                id={`own-form-ip`}
                                name="srv_ip"
                                placeholder="Server IP address"
                                value={form.srv_ip}
                                hint="*.*.*.*"
                                hintType='floating'
                                onChange={onChange}
                                iconLeft='fas fa-server'
                                disabled={disabledInputs}
                                messages={messages}
                                autoComplete="one-time-code"
                                required
                            />
                            <Input
                                className={styles.form__port}
                                id={`own-form-port`}
                                name="ssh_port"
                                placeholder="Port"
                                value={form.ssh_port ? form.ssh_port.toString() : ''}
                                hint="Example: 30022"
                                hintType='floating'
                                iconLeft='fas fa-network-wired'
                                onChange={onChange}
                                disabled={disabledInputs}
                                messages={messages}
                                autoComplete="one-time-code"
                                required
                            />
                            <Input
                                className={styles.form__login}
                                id={`own-form-user`}
                                name="ssh_user"
                                placeholder="Login"
                                value={form.ssh_user}
                                hint="In order to connect your server we will need to know user name."
                                hintType='floating'
                                iconLeft='fas fa-user-circle'
                                onChange={onChange}
                                disabled={disabledInputs}
                                messages={messages}
                                autoComplete="one-time-code"
                                required
                            />
                        </div>
                        <pre
                            className={`${styles.command}${allowedCopyWithoutConnect ? ' ' + styles['command--enabled'] : ''}`}
                            onClick={
                                allowedCopyWithoutConnect
                                    ? !disabledCopyAndConnect
                                        ? handleCopyAndConnect : handleCopyWithoutConnect
                                    : undefined
                            }
                            placeholder="Curl command"
                        >
                            <Messages
                                padding='10px 38px 5px 0'
                                messages={[{
                                    message: 'Login via SSH on your server and paste the command',
                                    type: 'info'
                                }]}
                            />
                            {
                                status === OWN_STATUS_LOADING
                                    ?
                                    <Loading className={styles.command__loading}/>
                                    :
                                    <code id='cmd-own' className={styles.command__code}>
                                        {cmd}
                                    </code>
                            }
                            <i className={`${allowedCopyWithoutConnect ? !disabledCopyAndConnect ? `fas fa-play` : `fas fa-copy` : `fas fa-copy`} ${styles.command__icon}`}/>
                        </pre>
                        <div className={styles.bottom}>
                            <Messages
                                className={styles.bottom__link}
                                messages={[{
                                    message: (
                                        <Link
                                            href={`${NAV_CLOUDS}/deploy-to-${generateSlug(currentCloud.name)}`}
                                            target='_blank'>
                                            Learn how to connect your server
                                        </Link>
                                    ),
                                    type: 'info'
                                }]}
                            />
                            {
                                !!DEBUG &&
                                <Button
                                    className={`${styles.bottom__button} ${styles.bottom__button__debug}`}
                                    onClick={() => setShowDebug(!showDebug)}
                                    displayType={showDebug ? 'contained' : 'text'}
                                    role='info'
                                    icon='fas fa-code'
                                    visuals={{colorBasic: [`var(--colorAccentLight)`]}}
                                />
                            }
                            <Button
                                className={`${styles.bottom__button} ${styles.bottom__button__refresh}`}
                                disabled={
                                    status === OWN_STATUS_IDLE
                                    || status === OWN_STATUS_SUCCESS
                                    || status === OWN_STATUS_LOADING
                                    || status === OWN_STATUS_WAIT_AGREE
                                }
                                onClick={
                                    () => {
                                        if (confirm('Refreshing the command will require you to re-run the script on your server')) {
                                            clearInterval(listeningInterval.current);
                                            pushOwnLog('Connection process has been stopped', undefined, 'error');
                                            getCMD()
                                        }
                                    }
                                }
                                title='Refresh code'
                                role='info'
                                iconRight='fas fa-redo-alt'
                            />
                            <Button
                                className={`${styles.bottom__button} ${styles.bottom__button__copy}`}
                                disabled={disabledCopyAndConnect && !allowedCopyWithoutConnect}
                                onClick={
                                    allowedCopyWithoutConnect
                                        ? !disabledCopyAndConnect
                                            ? handleCopyAndConnect : handleCopyWithoutConnect
                                        : undefined
                                }
                                title='Copy command'
                                iconRight={
                                    allowedCopyWithoutConnect
                                        ? !disabledCopyAndConnect
                                            ? 'fas fa-play' : 'fas fa-copy'
                                        : 'fas fa-lock'
                                }
                            />
                        </div>
                    </CardItem>
                    <CardItem>
                        <OwnLogs logs={logs}/>
                    </CardItem>
                </div>
            </Card>
            {
                !!DEBUG &&
                <OwnDebugger
                    showDebug={showDebug}
                    setStatus={_setStatus}
                    status={status}
                    connectError={connectError}
                    setConnectError={setConnectError}
                    pushOwnLog={pushOwnLog}
                />
            }
        </div>
    );
}

const mapStateToProps = state => ({
    currentCloud: state.deployment.currentCloud,
    currentStack: state.deployment.currentStack,
    bodyServer: state.deployment.bodyServer,
    // errorsInputs: deployment.errorsInputs,
    bodyCloud: state.deployment.bodyCloud,
    messages: state.deployment.messages,
});

export default connect(mapStateToProps)(OwnForm)